import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { StatColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { contentFilter } from '/utils/functions';

const BlockStats: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockBackgroundType,
  blockContent,
  presentOption,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const columnData = blockContent?.columns?.list || [];
  const contextContent = contentFilter(
    blockContent.context,
    presentMode,
    presentOption,
  );
  const contextStep = contextContent ? 1 : 0;
  const animationComplete = animationStep >= columnData.length + contextStep;
  setAnimationComplete(animationComplete);

  return (
    <ArticleBlock
      {...props}
      blockBackgroundType={blockBackgroundType}
      blockContent={blockContent}
      titleCentered
      rowCenterAlign
      offset={1}
      contextContent={contextContent}
      hideContext={animationEnabled && !animationStep}
      hideFooter={animationEnabled && !animationComplete}
      columnWidth={4}
      columns={columnData.map(
        (column: ColumnContainerJson, columnNumber: number) => (
          <>
            {!column.hidden && column.name === 'stat' && (
              <StatColumn
                background={blockBackgroundType}
                elements={column.elements}
                hide={
                  animationEnabled &&
                  animationStep <= columnNumber + contextStep
                }
              />
            )}
          </>
        ),
      )}
    />
  );
};

BlockStats.displayName = 'BlockStats';
export default BlockStats;
